import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { i18n } from "./config/i18n";
import VueGtag from "vue-gtag";
import config from "@/config";
import { createPinia } from "pinia";
import { createMetaManager } from "vue-meta";

const metaManager = createMetaManager();

if (config.buildMode === "dev") {
    console.log("buildMode DEV");
    // let googleAnalyticsId = config.isUS ? "G-DTEYN0TLZL" : "G-S99YEPR8D0";
    createApp(App)
        .use(router)
        .use(createPinia())
        .use(i18n)
        .use(metaManager)
        // .use(
        //     VueGtag,
        //     {
        //         config: {
        //             id: googleAnalyticsId, // Google Analytics의 Tracking ID를 넣어준다
        //         },
        //         consent: {
        //             ad_storage: "denied",
        //             analytics_storage: "denied",
        //             ad_user_data: "denied",
        //             ad_personalization: "denied",
        //         },
        //         pageTrackerScreenviewEnabled: true,
        //         enabled: true,
        //     },
        //     router,
        // )
        .mount("#app");
} else {
    console.log("buildMode Prod");
    // 미국향 G-DTEYN0TLZL
    // 한국향 G-S99YEPR8D0
    let googleAnalyticsId = config.isUS ? "G-DTEYN0TLZL" : "G-KDBFVPEWG2";
    createApp(App)
        .use(router)
        .use(createPinia())
        .use(i18n)
        .use(
            VueGtag,
            {
                config: {
                    id: googleAnalyticsId, // Google Analytics의 Tracking ID를 넣어준다
                },
                consent: {
                    ad_storage: "denied",
                    analytics_storage: "denied",
                    ad_user_data: "denied",
                    ad_personalization: "denied",
                },
                pageTrackerScreenviewEnabled: true,
                enabled: true,
            },
            router,
        )
        .use(metaManager)
        .mount("#app");
}

// 카카오 SDK 초기화
window.Kakao.init("d4cc318f2fd5a3801aa1759a7412b419");
